import { Form } from "rsuite";
import {
  TextInput,
  PasswordInput,
  TagInputWithIcon,
} from "../../../components/textInput.component";
import { Button } from "../../../components/button.component";
import { useCallback, useEffect, useState } from "react";
import {
  DoesObjectHasAnyInvalidValue,
  generateMultipartFormData,
} from "../../../utils/formUtils";
import {
  CompanyRegisterFormSchema,
  CompanyRegisterRequestType,
} from "../../../models/forms/companyRegisterForm";
import { AuthLayout } from "../../components/authLayout";
import { ApiCompany } from "../../../core/apis";
import { Link, useHistory } from "react-router-dom";
import { AppRouteUi } from "../../../config/appRoute";
import { ApiInsuranceTypes } from "../../../core/apis/insuranceTypes";

export const PageAuthCompanyRegister = () => {
  const [formData, setFormData] = useState<CompanyRegisterRequestType>({
    CompanyName: "",
    Email: "",
    AdminFirstName: "",
    AdminLastName: "",
    AdminEmail: "",
    AdminPhoneNumber: "",
    AdminPassword: "",
    AdminConfirmPassword: "",
    AdminUserName: "",
    ProviderNumber: "",
    InsuranceTypeIds: [],
  });
  const [formError, setFormError] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const routeHistory = useHistory();

  const { data: insuranceTypes } = ApiInsuranceTypes.GetInsuranceTypes.Hook();

  const insuranceTypeMap =
    insuranceTypes?.map((it) => ({
      label: it.displayName ?? it.name,
      value: it.sKey,
    })) ?? [];

  useEffect(() => {
    const isEmpty = Object.values({ ...formData }).some(
      DoesObjectHasAnyInvalidValue
    );
    const errorCount = Object.keys(formError).length;
    const isPasswordMatched =
      formData.AdminPassword !== "" &&
      formData.AdminConfirmPassword !== "" &&
      formData.AdminPassword?.match(formData.AdminConfirmPassword!);
    var isDisabled = isEmpty || !!errorCount || !isPasswordMatched;
    setIsDisabled(isDisabled);
  }, [formData, formError]);

  const handleChange = useCallback(
    (data: any, _: any) =>
      setFormData((prevFormData) => ({ ...prevFormData, ...data })),
    []
  );

  const handleSubmit = async (
    checked: boolean,
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    if (!checked) return;
    setIsLoading(true);
    const multipartFormData = generateMultipartFormData(formData);

    const result = await ApiCompany.Register(multipartFormData);

    if (result.isSuccess) routeHistory.push(AppRouteUi.Login.Root());

    setIsLoading(false);
  };

  return (
    <AuthLayout>
      <div className="w-100 d-flex flex-column my-auto">
        <h4 className="text-center fw-light">Register Your Company</h4>
        <Form
          className="border-bottom py-3"
          onChange={handleChange}
          onCheck={setFormError}
          formValue={formData}
          onSubmit={handleSubmit}
          model={CompanyRegisterFormSchema}
          fluid
        >
          <div className="px-4">
            <div className="row">
              <TextInput name="CompanyName" required>
                Company Name
              </TextInput>
              <TextInput name="Email" required>
                Company Email
              </TextInput>
            </div>
            <div className="row">
              <TextInput name="ProviderNumber" required>
                NPI/Provider Number
              </TextInput>
              <TagInputWithIcon
                name="InsuranceTypeIds"
                data={insuranceTypeMap}
                required
                value={formData.InsuranceTypeIds}
                placeholder="Select Insurance Types"
                renderEmpty={
                  <p className="text-muted p-3">No Data Available</p>
                }
              >
                Insurance type
              </TagInputWithIcon>
            </div>

            <div className="row">
              <TextInput name="AdminFirstName" required>
                Admin First Name
              </TextInput>
              <TextInput name="AdminLastName" required>
                Admin Last Name
              </TextInput>
            </div>

            <div className="row">
              <TextInput name="AdminUserName" fullWidth required>
                Admin Username
              </TextInput>
            </div>

            <div className="row">
              <TextInput name="AdminEmail" required>
                Admin Email
              </TextInput>
              <TextInput name="AdminPhoneNumber" required>
                Admin Phone Number
              </TextInput>
            </div>
            <div className="row">
              <PasswordInput name="AdminPassword" required>
                Password
              </PasswordInput>
              <PasswordInput
                name="AdminConfirmPassword"
                itemType="password"
                required
              >
                Confirm Password
              </PasswordInput>
            </div>
            {formData.AdminPassword !== formData.AdminConfirmPassword && (
              <p className="text-red-300">Password did not match</p>
            )}
          </div>

          <div className="d-flex justify-content-center flex-column align-items-center">
            <Button
              className="mt-3 px-5 btn-green"
              type="submit"
              name="Register"
              disabled={isDisabled}
              loading={isLoading}
            />
            <Link
              to={AppRouteUi.Login.Root()}
              className={`text-green-200 px-4 text-center d-block mt-2 ${
                isLoading ? "pe-none" : ""
              }`}
            >
              Already have an account?
            </Link>
          </div>
        </Form>
        <div className="d-flex justify-content-center">
          <p className="d-inline text-green-200 px-4 mt-3 text-center">
            By clicking register you agree our{" "}
            <a
              href={AppRouteUi.PrivacyPolicy.Root()}
              className={`text-green-200 text-decoration-underline ${
                isLoading ? "pe-none" : ""
              }`}
            >
              privacy policy
            </a>
            .
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};
